// 可扩展的项目列表：后端与前端共用
export const EVENTS = [
  { key: '3x3',   name: '三阶',   short: '3x3',   scramble: 'cube3',  defaultSolves: 5 },
  { key: '2x2',   name: '二阶',   short: '2x2',   scramble: 'cube2',  defaultSolves: 5 },
  { key: '4x4',   name: '四阶',   short: '4x4',   scramble: 'cube4',  defaultSolves: 5 },
  { key: '3bld',  name: '三盲',   short: '3BLD',  scramble: 'cube3',  defaultSolves: 3 },
  { key: 'oh',    name: '单手',   short: 'OH',    scramble: 'cube3',  defaultSolves: 5 },
  { key: 'pyraminx', name: '金字塔', short: 'Pyra', scramble: 'pyraminx', defaultSolves: 5 },
  { key: 'skewb', name: 'Skewb',  short: 'Skewb', scramble: 'skewb',  defaultSolves: 5 },
];

export function eventByKey(key) {
  return EVENTS.find((e) => e.key === key) || EVENTS[0];
}

export const EVENT_KEYS = EVENTS.map((e) => e.key);
